<template>
  <div class="car-info">
    <!-- id + type -->
    <el-row>
      <el-col :span="24" :xs="24" style="line-height: 30px">
        <span> [{{ carInfo.management_number }}]</span>
        <span style="padding-left: 10px">{{ carInfo.type }}</span>
      </el-col>
    </el-row>
    <el-divider />
    <el-row>
      <!-- img -->
      <el-col
        :span="12"
        :xs="24"
        style="position: relative"
        class="car-info-left"
      >
        <el-row>
          <el-image
            :src="carInfo.img"
            fit="cover"
            alt="Car Image"
            class="car-img"
          ></el-image>
          <el-image
            style="position: absolute; right: 8px; top: 8px; height: 100px"
            v-if="carInfo.soldOutFlg === '1'"
            :src="require('@/assets/sold-out-png-19955.png')"
            fit="cover"
            alt="Car Image"
          ></el-image>
        </el-row>
        <el-row style="padding-top: 10px">
          <div class="image-gallery">
            <!-- 小图片列表 -->
            <div class="thumbnail-container">
              <img
                v-for="(image, index) in imgList"
                :key="index"
                :src="image"
                @click="showImage(image, index)"
                class="thumbnail"
                alt="Car Thumbnail"
              />
            </div>
            <!-- vue-easy-lightbox 组件 -->
            <vue-easy-lightbox
              :visible="lightboxfDisp"
              :imgs="imgList"
              :index="index"
              @hide="lightboxfDisp = false"
            />
          </div>
        </el-row>
      </el-col>
      <el-col :span="12" :xs="24" class="car-info-right">
        <!-- 価格 -->
        <el-row style="margin-bottom: 8px">
          <el-col :span="24" :xs="24" class="car-info-right-price">
            <span class="car-info-right-price-title">
              {{ $t("car-info-price-title") }}
            </span>
            <span v-html="carInfo.price"></span>
          </el-col>
        </el-row>
        <el-divider border-style="dashed" />
        <el-row>
          <!-- 年式 -->
          <el-col :span="6" :xs="6" class="car-info-table-head">
            {{ $t("usedcar-year") }}</el-col
          >
          <!-- 評価点 -->
          <el-col
            :span="6"
            :xs="6"
            class="car-info-table-head car-info-table-border"
          >
            {{ $t("usedcar-evaluation") }}</el-col
          >
        </el-row>
        <el-row class="car-info-right-bottom">
          <!-- 年式 -->
          <el-col :span="6" :xs="6" class="car-info-table-body">{{
            carInfo.year
          }}</el-col>
          <!-- 評価点 -->
          <el-col
            :span="6"
            :xs="6"
            class="car-info-table-body car-info-table-border"
            >{{ carInfo.evaluation }}</el-col
          >
        </el-row>

        <!-- name -->
        <el-row class="car-info-right-bottom2">
          <el-col :span="6" :xs="6" class="car-info-right-title">
            {{ $t("part-info-name") }}
          </el-col>
          <el-col :span="18" :xs="18" class="car-info-right-content">
            {{ carInfo.name }}
          </el-col>
        </el-row>
        <!-- グレード -->
        <el-row class="car-info-right-bottom2">
          <el-col :span="6" :xs="6" class="car-info-right-title">
            {{ $t("usedcar-grade") }}
          </el-col>
          <el-col :span="18" :xs="18" class="car-info-right-content">
            {{ carInfo.grade }}
          </el-col>
        </el-row>
        <!-- 特記 -->
        <el-row class="car-info-right-bottom2">
          <el-col :span="6" :xs="6" class="car-info-right-title">
            {{ $t("usedcar-points") }}
          </el-col>
          <el-col :span="18" :xs="18" class="car-info-right-content" style="white-space: pre-line">
            {{ carInfo.points }}
          </el-col>
        </el-row>
        <!-- 掲載日 -->
        <el-row class="car-info-right-bottom2">
          <el-col :span="6" :xs="6" class="car-info-right-title">
            {{ $t("usedcar-publish-date") }}
          </el-col>
          <el-col :span="18" :xs="18" class="car-info-right-content">
            {{ carInfo.publish_date }}
          </el-col>
        </el-row>
        <!-- 管理番号 -->
        <el-row class="car-info-right-bottom2">
          <el-col :span="6" :xs="6" class="car-info-right-title">
            {{ $t("usedcar-management-number") }}
          </el-col>
          <el-col :span="18" :xs="18" class="car-info-right-content">
            {{ carInfo.management_number }}
          </el-col>
        </el-row>
        <el-divider border-style="dashed" />
        <el-row class="car-info-right-title-bgnone">
          <!-- 保証 -->
          <el-col :span="6" :xs="6"> {{ $t("car-info-warranty") }}</el-col>
          <el-col :span="18" :xs="18">{{ carInfo.warranty }}</el-col>
        </el-row>
        <el-row class="car-info-right-bottom car-info-right-title-bgnone">
          <!-- 整備 -->
          <el-col :span="6" :xs="7"> {{ $t("car-info-maintenance") }}</el-col>
          <el-col :span="18" :xs="17">{{ carInfo.maintenance }}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- お問合せされる方へ -->
    <el-row style="padding-top: 20px">
      <!-- 说明 -->
      <el-col :span="15" :xs="24">
        <el-tabs type="card" class="pc-disp">
          <el-tab-pane :label="$t('car-info-usedcar-sales')">
            <div v-html="aboutCar"></div>
          </el-tab-pane>
          <el-tab-pane :label="$t('car-info-evaluation-score')"
            ><div v-html="aboutEscore"></div
          ></el-tab-pane>
        </el-tabs>
        <el-collapse class="mobile-disp" accordion>
          <el-collapse-item :title="$t('car-info-usedcar-sales')">
            <div v-html="aboutCar"></div>
          </el-collapse-item>
          <el-collapse-item :title="$t('car-info-evaluation-score')">
            <div v-html="aboutEscore"></div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
      <!-- お問合せされる方へ -->
      <el-col :span="9" :xs="24" class="car-contact">
        <el-row
          style="
            background-color: rgb(26, 82, 118);
            color: white;
            line-height: 40px;
            padding-left: 10px;
          "
        >
          {{ $t("car-info-car-contact") }}
        </el-row>
        <el-row style="border: 1px solid #dcdfe6">
          <el-row class="fontinfo">
            {{ $t("home-contact-rifht-time") }} {{ contactInfo.time }}
          </el-row>
          <el-row class="fontinfo">
            {{ $t("car-info-car-title1") }}
          </el-row>
          <el-row class="fontinfo">
            {{ $t("car-info-car-title2") }}
          </el-row>
          <el-row class="fontinfo" style="padding-top: 10px">
            <el-col style="max-width: 80px">
              <el-button class="square-button" @click="addLineFriend">
                <img src="@/assets/line.png" class="button-icon" alt="Call" />
              </el-button>
            </el-col>
            <el-button class="circle-button" @click="callPhone">
              <img src="@/assets/call.png" class="button-icon" alt="Call" />
            </el-button>
          </el-row>
        </el-row>
        <el-row>
          <div class="contact-content">
            <!-- title2 -->
            <el-row>
              <el-col :span="24" :xs="24" class="contact-title2">
                {{ $t("contact-title2") }}</el-col
              >
            </el-row>
            <el-divider />
            <!-- 氏名 -->
            <el-row>
              <el-col :span="6" :xs="6" class="contact-field">
                {{ $t("contact-name") }}</el-col
              >
              <el-col :span="18" :xs="18" class="">
                <el-input
                  v-model="sendContactInfo.name"
                  class="contact-input"
                  size="large"
                />
              </el-col>
            </el-row>
            <el-divider />
            <!-- E-mail -->
            <el-row style="padding-top: 10px">
              <el-col :span="6" :xs="6" class="contact-field">
                {{ $t("contact-email") }}</el-col
              >
              <el-col :span="18" :xs="18" class="">
                <el-input
                  v-model="sendContactInfo.mail"
                  class="contact-input"
                  size="large"
                />
              </el-col>
            </el-row>
            <el-divider />
            <!-- お問い合わせ内容 -->
            <el-row>
              <el-col :span="6" :xs="6" class="contact-field">
                {{ $t("contact-content") }}</el-col
              >
              <el-col :span="18" :xs="18" class="">
                <el-input
                  v-model="sendContactInfo.content"
                  class="contact-input"
                  size="large"
                  maxlength="500"
                  show-word-limit
                  type="textarea"
                  :rows="20"
                />
              </el-col>
            </el-row>
            <el-divider />
            <el-row justify="center">
              <el-button
                size="large"
                style="background-color: rgb(26, 82, 118); color: white"
                @click="gotoReview()"
                >{{ $t("contact-btn") }}</el-button
              >
            </el-row>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="padding: 20px 0px" justify="center">
      <el-button size="large" class="gotolist-btn" @click="gotoList()">{{
        $t("car-info-goto-list-btn")
      }}</el-button>
    </el-row>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { ElLoading, ElMessage } from "element-plus";
import {
  formatToYen,
  formatToYen2,
  formatMileage,
  formatDisplacement,
  formatYearMonth,
  formatYearMonthDay,
  isEmpty,
  validateEmail,
} from "@/utils/utils";
import { supabase } from "@/supabase.js"; // Supabase 连接
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  components: {
    VueEasyLightbox, // 注册组件
  },
  setup() {
    const { locale, t } = useI18n();
    const router = useRouter();
    // carInfo
    const carInfo = ref({});
    const lightboxfDisp = ref(false);
    const index = ref(0);
    const aboutCar = ref("");
    const aboutEscore = ref("");
    // 問い合わせ基本情報
    const contactInfo = ref({});
    // 問い合わせ内容
    const sendContactInfo = ref({});

    // 車種list
    const modelList2 = ref([]);

    const imgList = ref([]);

    const modeName = ref("");

    const getModelList2 = async () => {
      modelList2.value = [];

      try {
        const { data, error } = await supabase
          .from("model_m")
          .select("code, name_ja, name_en"); // 获取 code 和 name 字段
        if (error) {
          console.error("Error fetching data:", error);
        } else {
          modelList2.value = data.map((item) => ({
            name: item[`name_${locale.value}`], // 动态根据语言选择字段
            code: item.code,
          }));
        }
      } catch (err) {
        console.error("Unexpected error:", err);
      }
    };

    const getCarTypeName = (code) => {
      console.log("code:" + code);
      const carType = modelList2.value.find((t) => t.code == code);
      return carType ? carType.name : "-"; // 如果找不到就返回 "-"
    };

    const getCarInfo = async () => {
      let management_number = localStorage.getItem("management_number_part");
      if (isEmpty(management_number)) {
        ElMessage({
          message: "system error",
          type: "warning",
        });
        return;
      }

      const { data, error } = await supabase
        .from("part_info")
        .select("*")
        .eq("management_number", management_number)
        .single();

      if (error) {
        ElMessage({
          message: "system error:no car info be found.",
          type: "warning",
        });
      } else {
        carInfo.value = {
          management_number: data.management_number, // 管理番号
          img: data.img,
          price: formatToYen2(data[`price_${locale.value}`], locale.value), // 価格
          manufacturer: data.manufacturer,
          type: getCarTypeName(data.type), // 車種
          year: formatYearMonth(data[`year_${locale.value}`], locale.value), // 年式
          evaluation: data[`evaluation_${locale.value}`], // 評価点
          grade: data[`grade_${locale.value}`], // グレード
          model: data[`model_${locale.value}`], // 型式
          publish_date: formatYearMonthDay(
            data[`publish_date_${locale.value}`],
            locale.value
          ), // 掲載日
          // management_number: data[`management_number_${locale.value}`], // 管理番号
          color: data[`color_${locale.value}`],
          warranty: data[`warranty_${locale.value}`],
          maintenance: data[`maintenance_${locale.value}`],
          soldOutFlg: data.sold_out_flg,
          points: data[`points_${locale.value}`]
            ? data[`points_${locale.value}`].replace(/\\n/g, "\n")
            : "",
          name: data[`name_${locale.value}`], //
        };

        const { data: modeDate } = await supabase
          .from("model_m")
          .select("code,  name_ja,name_en")
          .eq("code", 2);

        console.log("modeDate.name_en:" + modeDate.name_en);
        if (locale.value === "ja") {
          modeName.value = modeDate.name_ja;
        } else {
          modeName.value = modeDate.name_en;
        }
      }
    };

    const getAboutInfo = async () => {
      // 查询 about_info_m
      let { data: aboutData, error: aboutError } = await supabase
        .from("about_info_m")
        .select("name_ja, name_en")
        .eq("code", "usedpart")
        .single();

      if (aboutError) {
        ElMessage({
          message: "system error: no aboutCarMessage be found.",
          type: "warning",
        });
      } else {
        aboutCar.value = aboutData[`name_${locale.value}`];
      }

      // 查询 point_info_m
      let { data: pointData, error: pointError } = await supabase
        .from("point_info_m")
        .select("name_ja, name_en")
        .eq("code", "usedpart")
        .single();

      if (pointError) {
        ElMessage({
          message: "system error: no aboutEscoreMessage be found.",
          type: "warning",
        });
      } else {
        aboutEscore.value = pointData[`name_${locale.value}`];
      }
    };

    const getContactInfo = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select(
          "contact_tel, contact_fax, contact_mail, contact_time_ja, contact_time_en,contact_line"
        )
        .eq("id", "home_info")
        .single();

      if (error) {
        ElMessage({
          message: "system error: no aboutEscoreMessage be found.",
          type: "warning",
        });
      } else {
        contactInfo.value = {
          tel: data.contact_tel,
          fax: data.contact_fax,
          line: data.contact_line,
          time: data[`contact_time_${locale.value}`],
        };
      }

      // 取得問い合わせ情報
      const savedData = localStorage.getItem("contactInfo");
      if (savedData) {
        sendContactInfo.value = JSON.parse(savedData);
      }
    };

    const fetchSubFileList = async () => {
      const { data } = await supabase
        .from("img_info")
        .select("sub_imgurl ,id")
        .eq("kbn", "1")
        .eq("sub_id", carInfo.value.management_number);
      imgList.value = (data || []).map((item, index) => item.sub_imgurl);
    };

    const goback = () => {
      router.back(); // 返回上一个页面
    };
    const showImage = (img, idx) => {
      index.value = idx;
      lightboxfDisp.value = true;
    };
    const callPhone = () => {
      window.location.href = "tel:" + contactInfo.value.tel;
    };
    const addLineFriend = () => {
      // window.location.href = "line://ti/p/" + contactInfo.value.line;
      window.open("https://line.me/ti/p/hyWeWqxJHT", "_blank");
    };

    const gotoReview = () => {
      if (isEmpty(sendContactInfo.value.name)) {
        getErrorMessage(t("contact-name") + t("error-required"));
        return;
      }
      if (isEmpty(sendContactInfo.value.mail)) {
        getErrorMessage(t("contact-email") + t("error-required"));
        return;
      }
      if (isEmpty(sendContactInfo.value.content)) {
        getErrorMessage(t("contact-content") + t("error-required"));
        return;
      }
      if (!validateEmail(sendContactInfo.value.mail)) {
        getErrorMessage(t("email-invalid"));
        return;
      }

      var path = "/reviewContactContent";
      var query = sendContactInfo.value;
      // 提交或页面跳转时保存到 LocalStorage
      localStorage.setItem(
        "contactInfo",
        JSON.stringify(sendContactInfo.value)
      );
      router.push({ path, query });
    };
    const getErrorMessage = (message) => {
      ElMessage({
        message: message,
        type: "warning",
      });
    };
    const gotoList = () => {
      localStorage.setItem("from", "carInfo");
      router.back(); // 返回上一个页面
    };

    onMounted(async () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await getModelList2();
      await getCarInfo();
      await fetchSubFileList();
      await getAboutInfo();
      await getContactInfo();
      loading.close();
    });
    watch(locale, async () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await getModelList2();
      await getCarInfo();
      await fetchSubFileList();
      await getAboutInfo();
      await getContactInfo();
      loading.close();
    });

    return {
      carInfo,
      aboutCar,
      contactInfo,
      sendContactInfo,
      aboutEscore,
      lightboxfDisp,
      goback,
      index,
      showImage,
      callPhone,
      addLineFriend,
      gotoReview,
      gotoList,
      modeName,
      imgList,
    };
  },
};
</script>

<style scoped>
.car-info {
  padding: 30px 80px;
}
.el-divider--horizontal {
  border-top: 1px var(--el-border-color) var(--el-border-style);
  display: block;
  height: 1px;
  margin: 12px 0;
  width: 100%;
}
.sold-out-banner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(339deg); /* 调整倾斜角度 */
  /* color: white; */
  font-size: 80px;
  font-weight: bold;
  /* padding: 10px 20px; */
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  background: linear-gradient(to right, red, #f1dbdb);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.car-info-left {
  padding-right: 15px;
}
.car-info-right {
  border: 1px solid #dcdfe6;
  padding: 5px;
  border-radius: 3px;
  text-align: left;
}
.car-info-right-price {
  background: rgb(26, 82, 118);
  font-size: 30px;
  line-height: 60px;
  color: white;
  border: 1px solid rgb(26, 82, 118);
  padding-left: 8px;
}
.car-info-right-price-title {
  font-size: 15px;
  padding-right: 20px;
}
.car-info-right-bottom {
  padding-bottom: 8px;
  line-height: 30px;
}
.car-info-right-bottom2 {
  padding-bottom: 1px;
  line-height: 30px;
  font-size: 13px;
}
.car-info-right-title-bgnone {
  font-size: 13px;
}
.car-info-right-title {
  text-align: left;
  background: rgb(26, 82, 118);
  color: white;
  padding-left: 8px;
}
.car-info-right-content {
  text-align: left;
  padding-left: 8px;
  background: linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%);
}
.image-gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 小图片容器 */
.thumbnail-container {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(100px, 1fr)
  ); /* 根据屏幕调整列数 */
  gap: 10px;
  width: 100%;
}

.car-info-table-head {
  /* background: linear-gradient(90deg, #e7f1f4 0%, #e7f1f4 100%); */
  background: rgb(26, 82, 118);
  color: white;
  text-align: center;
  /* font-size: 13px; */
  font-size: 15px;
  line-height: 30px;
  border: 1px solid #dcdfe6;
}
.car-info-table-border {
  border-left: none !important;
}
.car-info-table-body {
  text-align: center;
  font-size: 13px;
  border: 1px solid #dcdfe6;
  border-top: none;
}

/* 小图片样式 */
.thumbnail {
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 2px;
  transition: transform 0.2s ease-in-out;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}

.thumbnail:hover {
  transform: scale(1.1);
}
.vel-modal {
  background: rgba(0, 0, 0, 0.8);
  bottom: 0;
  left: 0;
  margin: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9998;
}
/* 修改选中 tab 的背景色 */
:deep(.el-tabs__item.is-active) {
  color: #ffffff !important; /* 选中的 tab 文字颜色 */
  font-weight: bold;
  background-color: rgb(26, 82, 118) !important; /* 选中的 tab 背景颜色 */
}

/* 修改未选中的 tab 颜色 */
:deep(.el-tabs__item) {
  color: #666 !important;
}

/* 修改 tab 鼠标悬停时的颜色 */
:deep(.el-tabs__item:hover) {
  /* background-color: #56ABE4; */
  color: #56abe4 !important;
}
:deep(.el-tabs__header) {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0px;
  padding: 0;
  position: relative;
}
:deep(.el-tabs__content) {
  border: 1px solid #dcdfe6;
  padding: 15px;
}
:deep(.el-tabs--card > .el-tabs__header) {
  border-bottom: none;
  height: var(--el-tabs-header-height);
}

.pc-disp {
  display: auto;
}
.mobile-disp {
  display: none;
}
.car-contact {
  padding-left: 8px;
}
.fontinfo {
  font-size: 13px;
  line-height: 30px;
  padding-left: 10px;
  width: 100%;
}
.circle-button {
  width: 60px;
  height: 60px;
  border-radius: 50%; /* 让按钮变成圆形 */
  background-color: transparent; /* 默认背景透明 */
  display: flex;
  align-items: center;
  justify-content: center;
  border: none; /* 去掉默认边框 */
  transition: background-color 0.3s ease, transform 0.1s ease;
}

.square-button {
  width: 60px;
  height: 60px;
  background-color: transparent; /* 默认背景透明 */
  display: flex;
  align-items: center;
  justify-content: center;
  border: none; /* 去掉默认边框 */
  transition: background-color 0.3s ease, transform 0.1s ease;
}
.square-button:hover {
  background-color: rgba(0, 0, 0, 0.1); /* 悬停时有浅色背景 */
}

.square-button:active {
  background-color: rgba(0, 0, 0, 0.2); /* 按下时背景变深 */
  transform: scale(0.9); /* 按下时稍微缩小，形成按压效果 */
}

.circle-button:hover {
  background-color: rgba(0, 0, 0, 0.1); /* 悬停时有浅色背景 */
}

.circle-button:active {
  background-color: rgba(0, 0, 0, 0.2); /* 按下时背景变深 */
  transform: scale(0.9); /* 按下时稍微缩小，形成按压效果 */
}

.button-icon {
  width: 50px; /* 调整图片大小 */
  height: 50px;
}

.contact-content {
  padding: 25px;
  margin: 10px 0px;
  font-size: 13px;
  border: 1px solid #dcdfe6;
  background: linear-gradient(90deg, #e7f1f4 0%, #e7f1f4 100%);
}
.gotolist-btn {
  height: 50px;
  width: 200px;
  background-color: #1a5276;
  color: white;
}
.gotolist-btn:hover {
  background-color: #56abe4;
  color: white;
}
@media (max-width: 768px) {
  .car-info {
    padding: 20px 20px 0px 20px;
  }
  .car-info-right {
    margin-top: 8px;
    border: 1px solid #dcdfe6;
    padding: 5px;
    border-radius: 5px;
  }

  .car-info-left {
    padding-right: 0px;
  }
  .pc-disp {
    display: none;
  }
  .mobile-disp {
    display: block;
  }
  .car-contact {
    padding-top: 20px;
    padding-left: 0px;
  }
}
</style>
